import React from 'react'

const SectionHeading = ({ title, actionLabel, onAction, align = 'left', className = '' }) => (
  <div className={`section-heading ${align === 'center' ? 'section-heading-center' : ''} ${className}`}>
    <span className="section-title-text">{title}</span>
    {actionLabel && onAction && (
      <button className="text-sm font-semibold card-cta" onClick={onAction}>
        {actionLabel} →
      </button>
    )}
  </div>
)

export default SectionHeading
